<svelte:options accessors={true} />

<script>
    import SelectUnits from "./SelectUnits.svelte";
    import { t } from "../../../lang/lang.js";

    export let name;
    export let value;
    export let unit;
    export let error;
    let input;
    $: active = !!value;

    export function validate() {
        if (active && value === '') {
            error = false;
        } else {
            error = !value || Number.isNaN(Number(value)) || value < 1;
        }
        return !error;
    }

    function handleFocus() {
        active = true;
    }

    function handleBlur(event) {
        if (event.target.value === '') {
            active = false;
        }
        validate();
    }

    function inputMount(node) {
        if (node.value !== '') {
            active = true;
        }
    }

    export function focus() {
        input.focus();
    }
</script>

<div class="arsize_input_group">
    <div class="arsize_input_group_prepend">
        <div class="arsize_form_group">
            <input
                use:inputMount
                class="arsize_form_control"
                class:arsize_active={active}
                class:arsize_valid_error={error}
                bind:this={input}
                on:focus={handleFocus}
                on:blur={handleBlur}
                on:keyup={validate}
                bind:value={value}
                type="number" min="1">
            <div class="arsize_form_label">{ t('widget.' + name) }</div>
        </div>
    </div>
    <SelectUnits bind:value={unit} />
</div>

<style>
    input {
        box-sizing: border-box;
    }
    .arsize_input_group {
        display: flex;
        align-items: stretch;
        width: 100%;
        max-width: 254px;
    }
    .arsize_input_group_prepend {
        width: 71%;
    }
    .arsize_form_group {
        position: relative;
    }
    .arsize_form_control {
        height: auto;
        width: 100%;
        border: 2px solid #BEC7D2;
        font-size: 20px;
        line-height: 1;
        font-weight: 500;
        color: #7F8287;
        padding: 29px 16px 8px 16px;
        border-radius: 10px 0 0 10px;
        box-shadow: none;
        -webkit-appearance: none;
        -moz-appearance: none;
    }
    .arsize_form_control:focus {
        outline: none;
        box-shadow: none;
    }
    .arsize_form_control:focus ~ .arsize_form_label,
    .arsize_active ~ .arsize_form_label {
        top: -13px;
        left: 19px;
        font-size: 14px;
    }
    :global(.arsize_color_green) .arsize_form_control:focus {
        border-color: #4CC499;
    }
    .arsize_valid_error {
        border-color: #EB5757;
    }
    .arsize_form_label {
        position: absolute;
        pointer-events: none;
        left: 16px;
        top: 0;
        line-height: 64px;
        transition: .4s;
        margin-bottom: 0;
        color: #7F8287;
    }
    @media (max-width: 1279.98px) {
        .arsize_input_group {
            max-width: 100%;
        }
        .arsize_input_group_prepend {
            width: 76%;
        }
        .arsize_form_control {
            font-size: 16px;
            padding: 28px 16px 7px 16px;
            border-radius: 8px 0 0 8px;
            height: 57px;
        }
        .arsize_active ~ .arsize_form_label {
            font-size: 12px;
        }
        .arsize_form_label {
            line-height: 58px;
        }
    }
</style>